import { render, staticRenderFns } from "./Tabs.vue?vue&type=template&id=38a2e03e&scoped=true&"
import script from "./Tabs.vue?vue&type=script&lang=js&"
export * from "./Tabs.vue?vue&type=script&lang=js&"
import style0 from "./Tabs.vue?vue&type=style&index=0&id=38a2e03e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a2e03e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wp/Desktop/chuanti-pc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38a2e03e')) {
      api.createRecord('38a2e03e', component.options)
    } else {
      api.reload('38a2e03e', component.options)
    }
    module.hot.accept("./Tabs.vue?vue&type=template&id=38a2e03e&scoped=true&", function () {
      api.rerender('38a2e03e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/Tabs.vue"
export default component.exports